import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";


export const Main = styled.div`
  min-height: calc(100vh - 48px);
  margin-top: 48px;

  .disabled-layer {
    opacity: 0.5;
    pointer-events: none;
  }

  .hidden-layer {
    display: none;
    opacity: 0;
    transition: display 0s linear 0.33s, opacity 0.33s linear;
  }

  &.visible-layer {
    display: flex;
    opacity: 1;
    transition-delay: 0s;
  }

  .bottom-fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

export const OtherPaymentOffersWrapper = styled.div`
  margin-top: ${({ isVisible }: UiTheme) => (isVisible ? "12px" : "0")};
`;

export const UpiModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 5;
  overflow: hidden;
  background: white;
  display: ${({ isVisible }: UiTheme) => (isVisible ? "block" : "none")};
  top: 16px;
`;

export const MainLoaderLoayoutWrapper = styled.div`
  margin-top: 110px;
`;
